module.exports = __webpack_public_path__ + "static/media/add_reflect.836bdd79.svg";